// Import all components for factory function
import { QuizQuestionRenderer } from './QuizQuestionRenderer';
import { MultipleChoiceComponent } from './MultipleChoiceComponent';
import { SliderComponent } from './SliderComponent';
import { DragDropComponent } from './DragDropComponent';
import { TextInputComponent } from './TextInputComponent';
import { HotspotComponent } from './HotspotComponent';
// Base interface for all interactive components
export interface BaseInteractiveProps {
  exercise: any;
  onAnswer: (answer: any) => void;
  showFeedback?: boolean;
  disabled?: boolean;
}

// Re-export all components
export { QuizQuestionRenderer };
export { MultipleChoiceComponent };
export { SliderComponent };
export { DragDropComponent };
export { TextInputComponent };
export { HotspotComponent };

// Component factory function
export const getInteractiveComponent = (interactiveType: string) => {
  switch (interactiveType) {
    case 'SIMULATION':
      return SliderComponent;
    case 'DRAG_DROP':
    case 'SORTING':
    case 'MATCHING':
      return DragDropComponent;
    case 'TEXT_INPUT':
      return TextInputComponent;
    case 'HOTSPOT':
      return HotspotComponent;
    case 'QUIZ':
      return QuizQuestionRenderer;
    case 'GUIDED_ANALYSIS':
    case 'APPLIED_PRACTICE':
    case 'SCENARIO_BASED':
    default:
      return MultipleChoiceComponent;
  }
};
